module.exports = __webpack_public_path__ + "img/5-off.e3adcc19.png";